/* ============================================================
   Hero Home Slider — Swiper initialisation
   Reads all config from data-* attributes so multiple
   section instances on the same page work independently.
   ============================================================ */

(function () {
  function initSliders() {
    document.querySelectorAll('.hero-home-slider__swiper').forEach(function (el) {
      var loop        = el.dataset.loop === 'true';
      var speed       = parseInt(el.dataset.speed, 10) || 700;
      var doAutoplay  = el.dataset.autoplay === 'true';
      var autoplayMs  = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      var effect      = el.dataset.effect || 'fade';

      var config = {
        loop: loop,
        speed: speed,
        effect: effect,
        navigation: {
          nextEl: el.querySelector('.hero-home-slider__nav--next'),
          prevEl: el.querySelector('.hero-home-slider__nav--prev'),
        },
        pagination: {
          el: el.querySelector('.hero-home-slider__pagination'),
          clickable: true,
        },
        keyboard: { enabled: true },
        a11y: {
          prevSlideMessage: 'Slide anterior',
          nextSlideMessage: 'Siguiente slide',
        },
      };

      if (effect === 'fade') {
        config.fadeEffect = { crossFade: true };
      }

      if (doAutoplay) {
        config.autoplay = {
          delay: autoplayMs,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      var swiper = new Swiper(el, config);

      function syncVideos() {
        el.querySelectorAll('.hero-home-slider__bg-video, .hero-home-slider__secondary-video').forEach(function (v) {
          v.pause();
        });
        var activeSlide = swiper.slides[swiper.activeIndex];
        if (activeSlide) {
          var videos = activeSlide.querySelectorAll('.hero-home-slider__bg-video, .hero-home-slider__secondary-video');
          videos.forEach(function(v) {
            v.muted = true;
            v.playsInline = true;
            v.currentTime = 0;
            var playPromise = v.play();
            if (playPromise !== undefined) {
              playPromise.catch(function () {});
            }
          });
        }
      }

      swiper.on('slideChangeTransitionEnd', syncVideos);
      syncVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
